export const LOADING_MODAL_I18N_PREFIX = "features.topics.components.loading_modal";

export const LOADING_MODAL_I18N_KEYS = {
  uploading: "uploading",
  cancel:    "cancel"
};



// WEBPACK FOOTER //
// ./src/features/topics/components/constants/i18n/LoadingModali18nConstants.js